exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Avatar__avatar__1Xb5i{border-radius:50%;--default-size:3.28571rem;height:var(--default-size);width:var(--default-size);object-fit:cover}.Avatar__avatar__1Xb5i.Avatar__small__14r9W{--default-size:2.28571rem}.Avatar__avatar__1Xb5i.Avatar__large__2CGps{--default-size:5.57143rem}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/src/components/controls/Avatar.scss"],"names":[],"mappings":"AAEA,uBACE,kBAAkB,AAClB,0BAAe,AACf,2BAA+B,AAC/B,0BAA8B,AAC9B,gBAAiB,CAUlB,AAfD,4CAUI,yBAAe,CAChB,AAXH,4CAaI,yBAAe,CAChB","file":"Avatar.scss","sourcesContent":["@import '../../styles/mixins.scss';\n\n.avatar {\n  border-radius: 50%;\n  --default-size: #{rem(46px)};\n  height: rem(var(--default-size));\n  width: rem(var(--default-size));\n  object-fit: cover;\n\n  // Sizes\n  &.medium {}\n  &.small {\n    --default-size: #{rem(32px)};\n  }\n  &.large {\n    --default-size: #{rem(78px)};\n  }\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"avatar": "Avatar__avatar__1Xb5i",
	"small": "Avatar__small__14r9W",
	"large": "Avatar__large__2CGps"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/Avatar.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/Avatar.scss
// module chunks = 0